<template>
    <div class="mainBody">
        <el-card class="box-card" style="width: 600px;margin: 100px auto">
            <div slot="header" class="clearfix">
                            <span class="title-bar"></span>
                <span>代码生成器</span>
            </div>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="表名" prop="tableName">
                    <el-input v-model="form.tableName"></el-input>
                </el-form-item>
                <el-form-item label="类名" prop="className">
                    <el-input v-model="form.className"></el-input>
                </el-form-item>
                <el-form-item label="变量名" prop="blName">
                    <el-input v-model="form.blName"></el-input>
                </el-form-item>
                <el-form-item label="包名" prop="xxName">
                    <el-input v-model="form.xxName"></el-input>
                </el-form-item>
                <el-form-item label="标题" prop="title">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="菜单ID" prop="menuId">
                    <el-input v-model.number="form.menuId"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
                    <el-button @click="reSetForm" size="medium">重 置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import { saveModel } from '@/api/common'

export default {
    name: "creator",
    data() {
        return {
            form: {
                tableName: 'm_banner',
                className: 'Banner',
                blName: 'banner',
                xxName: 'banner',
                title: '测试',
                menuId: 100
            },
            rules :{
                tableName: [
                    {required: true, message: '表名不能为空', trigger: 'blur'},
                ],
                className: [
                    {required: true, message: '类名不能为空', trigger: 'blur'},
                ],
                blName: [
                    {required: true, message: '变量名不能为空', trigger: 'blur'},
                ],
                xxName: [
                    {required: true, message: '包名不能为空', trigger: 'blur'},
                ],
                title: [
                    {required: true, message: '标题不能为空', trigger: 'blur'},
                ],
                menuId: [
                    {required: true, message: '菜单ID不能为空', trigger: 'blur'},
                    {type: 'number', message: '菜单ID必须是数字值', trigger: 'blur'}
                ]
            }
        }
    },
    methods: {
        reSetForm(){
            this.$refs["form"].resetFields()
        },
        handleSubmit() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    let config = {
                        url:'/api/admin/creator'
                    }
                    config["data"] = this.form;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("生成成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                    
                }
            })
        }
    }
};
</script>